import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { useAdminAuth } from "../context/AdminAuthContext";
import logo from "../assets/logo.png";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(form);
      const dest = location.state?.from?.pathname || "/admin";
      navigate(dest, { replace: true });
    } catch (err) {
      setError(err.friendlyMessage || "Could not log you in.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="pm-auth-shell">
      <Link to="/" className="pm-auth-shell__back pm-btn pm-btn--ghost pm-btn--sm">
        ← Back to home
      </Link>
      <motion.div className="pm-auth-card" initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>
        <Link to="/" className="pm-auth-brand">
          <img src={logo} alt="Positive Moves" className="pm-brand-logo" />
        </Link>
        <h1>Admin login</h1>
        <p className="pm-auth-sub">Access is restricted to the hiring team. Accounts are created directly, not self-registered.</p>

        <form onSubmit={handleSubmit} className="pm-auth-form">
          <div className="pm-field">
            <label>Email address</label>
            <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div className="pm-field">
            <label>Password</label>
            <input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
          </div>
          {error && <div className="pm-form-error">{error}</div>}
          <button className="pm-btn pm-btn--primary pm-btn--lg" disabled={loading} type="submit">
            {loading ? "Logging in…" : "Log in"}
          </button>
        </form>

        <p className="pm-auth-switch">
          <Link to="/student/login">Student login</Link> · <Link to="/panel/login">Panel login</Link>
        </p>
      </motion.div>
    </div>
  );
}